"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Form = _interopRequireDefault(require("../hocs/Form"));
var _templateObject, _templateObject2, _templateObject3;
const _excluded = ["label", "name"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const propTypes = {
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  name: _propTypes.default.string.isRequired,
  height: _propTypes.default.number,
  withBorder: _propTypes.default.bool,
  resize: _propTypes.default.string
};
const defaultProps = {
  height: 100,
  resize: 'none'
};
function TextareaComponent(_ref) {
  var _errors$name2, _errors$name3;
  let {
      label,
      name
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    register,
    formState: {
      errors
    }
  } = _Form.default.useForm();
  const hasError = (0, _react.useMemo)(() => {
    var _errors$name;
    return !!(errors !== null && errors !== void 0 && (_errors$name = errors[name]) !== null && _errors$name !== void 0 && _errors$name.message);
  }, [errors === null || errors === void 0 || (_errors$name2 = errors[name]) === null || _errors$name2 === void 0 ? void 0 : _errors$name2.message]);
  return /*#__PURE__*/_react.default.createElement(Wrapper, props, label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: name
  }, label), /*#__PURE__*/_react.default.createElement(Textarea, _extends({}, props, register(name), {
    id: name,
    name: name,
    hasError: hasError
  })), hasError && /*#__PURE__*/_react.default.createElement(ErrorMessage, null, String(errors === null || errors === void 0 || (_errors$name3 = errors[name]) === null || _errors$name3 === void 0 ? void 0 : _errors$name3.message)));
}
const Wrapper = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n\n  label {\n    font-weight: 700;\n  }\n"])));
const Textarea = _styled.default.textarea(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-radius: 10px;\n  padding: 15px;\n  border: 1px solid ", ";\n  resize: ", ";\n\n    \n  ", "\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    display: none;\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  ", "\n\n  ", "\n\n"])), _ref2 => {
  let {
    theme,
    withBorder
  } = _ref2;
  return withBorder ? theme.colors.NEUTRAL.SELECTED : theme.colors.NEUTRAL.TRANSPARENT;
}, _ref3 => {
  let {
    resize
  } = _ref3;
  return resize;
}, _ref4 => {
  let {
    theme,
    hasError
  } = _ref4;
  return hasError && "border: 1px solid ".concat(theme.colors.MAIN.ERROR, ";");
}, _ref5 => {
  let {
    height
  } = _ref5;
  return height && "height: ".concat(height, "px;");
}, _ref6 => {
  let {
    error,
    theme
  } = _ref6;
  return error && "\n      border: 1px solid ".concat(theme.colors.error, ";\n      border-radius: 5px;\n  ");
});
const ErrorMessage = _styled.default.small(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  & {\n    color: ", ";\n    text-align: end;\n    padding: 0 5px;\n  }\n"])), _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.MAIN.ERROR;
});
TextareaComponent.propTypes = propTypes;
TextareaComponent.defaultProps = defaultProps;
var _default = exports.default = TextareaComponent;